import PropTypes from 'prop-types';
import ProgressBar from "@ramonak/react-progress-bar";
import Utils from 'general/utils/Utils';

KTBSProgressBar.propTypes = {
    value: PropTypes.number,
    maxValue: PropTypes.number,
    customLabel: PropTypes.string,
    bgColor: PropTypes.string,
    baseBgColor: PropTypes.string,
    labelColor: PropTypes.string,
    labelSize: PropTypes.number,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    height: PropTypes.number,
    showValue: PropTypes.bool,
};

KTBSProgressBar.defaultProps = {
    baseBgColor: '#DBDFF1',
    bgColor: '#30BD6F',
    maxValue: 100,
    value: 0,
    labelColor: '#FFFFFF',
    labelSize: 10,
    width: '100%',
    height: 12,
    showValue: true,
};

function KTBSProgressBar(props) {
    // MARK: ---- PROPERTIES ----
    const { completed, value, maxValue, customLabel, bgColor, baseBgColor, labelColor, width, height, labelSize, showValue } = props;
    // MARK: ---- METHODS ----

    return (
        <div className="d-flex flex-column gap-2 w-100">
            <ProgressBar
                width={width}
                height={height}
                labelSize={labelSize}
                completed={completed}
                maxCompleted={100}
                customLabel={customLabel}
                bgColor={bgColor}
                baseBgColor={baseBgColor}
                labelColor={labelColor}
                labelAlignment={completed <= 30 ? '' : 'right'}
            />

            {showValue && (
                <div className='d-flex justify-content-between'>
                    <div style={{ color: bgColor }}>
                        {Utils.formatNumber(value)}
                    </div>
                    <div>
                        {Utils.formatNumber(maxValue)}
                    </div>
                </div>
            )}
        </div>
    );
}

export default KTBSProgressBar;
